import { z } from "zod";

export const workTypeSchema = z.enum(["remote", "hybrid", "onsite", "any"]);

export const scrapeSourceSchema = z.enum(["linkedin", "indeed", "stepstone", "xing"]);

export const searchCriteriaInput = z.object({
  name: z.string().min(1).max(100),
  role: z.string().min(2),
  location: z.string().optional(),
  salaryMin: z.number().int().positive().optional(),
  salaryMax: z.number().int().positive().optional(),
  currency: z.string().length(3).default("EUR"),
  workType: workTypeSchema.default("any"),
  sources: z.array(scrapeSourceSchema).min(1).max(4),
});

export const searchCriteriaSchema = z.object({
  id: z.string(),
  userId: z.string(),
  name: z.string(),
  role: z.string(),
  location: z.string().nullable(),
  salaryMin: z.number().nullable(),
  salaryMax: z.number().nullable(),
  currency: z.string(),
  workType: workTypeSchema,
  sources: z.array(z.string()),
  isActive: z.boolean(),
  alertEmail: z.boolean(),
  alertInApp: z.boolean(),
  lastScrapedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const scrapedJobSchema = z.object({
  id: z.string(),
  userId: z.string(),
  searchCriteriaId: z.string(),
  externalId: z.string(),
  source: scrapeSourceSchema,
  title: z.string(),
  company: z.string(),
  location: z.string().nullable(),
  salary: z.string().nullable(),
  url: z.string(),
  description: z.string().nullable(),
  postedAt: z.string().nullable(),
  atsScore: z.number().nullable(),
  isNew: z.boolean(),
  createdAt: z.string(),
});

export type WorkType = z.infer<typeof workTypeSchema>;
export type ScrapeSource = z.infer<typeof scrapeSourceSchema>;
export type SearchCriteriaInput = z.infer<typeof searchCriteriaInput>;
export type SearchCriteria = z.infer<typeof searchCriteriaSchema>;
export type ScrapedJob = z.infer<typeof scrapedJobSchema>;
